
import { configureStore } from "@reduxjs/toolkit";
import adminSlice from "./adminSlice"; 
import globalizationReducer from "./globalizationSlice"; 
import authReducer from "./authSlice";
import loadingReducer from './loadingSlice';
import timeZoneReducer from './timeSlice';
import hoaSlice from './Slice';

const store = configureStore({
  reducer: {
    admin: adminSlice,
    globalization: globalizationReducer,    
    auth: authReducer,
    loading: loadingReducer,
    timeZone: timeZoneReducer,
    hoa: hoaSlice,
  },
});

export default store;
